import axios from "axios";

const API_URL = process.env.API_URL;

export function addPhotographySolutionRequest(data) {
  return axios({
    method: "post",
    url: API_URL + "/google-photography-solution",
    data: data,
  });
}

export function getPhotographyCompanyRequest(slug) {
  return axios({
    method: "get",
    url: API_URL + "/photography-solution/getCompany/" + slug
  });
}



// WEBPACK FOOTER //
// ./src/actions/photographerActions.js